import { AssetClass } from "types/AssetClass";
import { Summary } from "types/Summary";
import { createCustomAction } from "typesafe-actions";

const SUMMARY_DATA_LOAD = "SUMMARY/SUMMARY_DATA_LOAD";
const SUMMARY_DATA_LOAD_SUCCESS = "SUMMARY/SUMMARY_DATA_LOAD_SUCCESS";
const SUMMARY_DATA_LOAD_FAIL = "SUMMARY/SUMMARY_DATA_LOAD_FAIL";

export type SummaryContentType = "all" | keyof typeof AssetClass;

export const load = createCustomAction(
  SUMMARY_DATA_LOAD,
  (type) => (contentType: SummaryContentType) => ({
    type,
    contentType,
  })
);

export const loadSuccess = createCustomAction(
  SUMMARY_DATA_LOAD_SUCCESS,
  (type) => (contentType: SummaryContentType, data?: Summary[]) => ({
    type,
    contentType,
    data,
  })
);

export const loadFail = createCustomAction(
  SUMMARY_DATA_LOAD_FAIL,
  (type) => (contentType: SummaryContentType, error?: string) => ({
    type,
    contentType,
    error,
  })
);
